import DhipayaSabaijaiCard from "./DhipayaSabaijaiCard";
import DhipayaSabaijaiDetails from "./DhipayaSabaijaiDetails";
import "./dhipaya_sabaijai.css";

export default {
  id: "dhipaya_sabaijai_2p3p",
  company: "ทิพยประกันภัย (Dhipaya)", // ✅ ตรงกับ COMPANY_INFO
  productLine: "motor",
  categories: ["car", "pickup"],
  nameTH: "สบายใจชัวร์ 2+ / 3+",
  description: "ประกันภัยรถส่วนบุคคล และ ปิกอัพ ≤ 3 ตัน คุ้มครองชนกับยานพาหนะทางบก",
  accent: "#003399",
  expiresAt: "2025-12-31",
  card: DhipayaSabaijaiCard,
  detail: DhipayaSabaijaiDetails,
  active: true,
};
